import { render, staticRenderFns } from "./Magazines.vue?vue&type=template&id=a5d79fc0&scoped=true&"
import script from "./Magazines.vue?vue&type=script&lang=js&"
export * from "./Magazines.vue?vue&type=script&lang=js&"
import style0 from "./Magazines.vue?vue&type=style&index=0&id=a5d79fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d79fc0",
  null
  
)

export default component.exports